import React, { Fragment, ReactElement, useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

import ModalDialog from 'src/components/ModalDialog';
import { ILoadState, IRack, } from 'src/types';
import { FormInput } from 'src/components/Form';
import API from '@sesame/web-api';
import Alert, { AlertTypes } from 'src/components/AlertDisplay';
import { Spinner } from 'src/components/Spinner';


interface IRackEditProps {
  rack: IRack;
  onEditSave: () => Promise<void>;
}

type IFormData = { identifier: string; description: string } & { [key: string]: string };
type fieldNames = keyof IFormData;

export const EditRack = ({ rack, onEditSave }: IRackEditProps) => {
  const  {isLoading, isAuthenticated, getAccessTokenSilently } = useAuth0();
  const [formData, setFormData] = useState<IFormData>({
    identifier: rack.identifier,
    description: rack.description,
  });
  const [validation, setValidation] = useState<fieldNames[]>([]);

  const dialogId = `editrack-${rack.rackId}`;
  const cancel = (event: React.UIEvent<HTMLAnchorElement>) => {
    const el = document.getElementById(dialogId);
    if (el) {
      el.click();
    }
  }

  const saveEdit = (event: React.UIEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    if (!rack.identifier) {
      return;
    }

    rack.identifier = formData.identifier;
    rack.description = formData.description;

    getAccessTokenSilently().then(accessToken => {
    API.patch(accessToken, `/api/v1/rack/`, rack)
      .then(res => {
        onEditSave()
        const el = document.getElementById(dialogId);
        if (el) {
          el.click();
        }
      })
      .catch(err => {
        Alert(AlertTypes.ERROR, err.message);
      })
    });
  }

  const formChange = (item: fieldNames, event: React.FormEvent<HTMLInputElement | HTMLSelectElement>) => {
    const newFormData = { ...formData };
    newFormData[item] = event.currentTarget.value;

    setFormData(newFormData);
    if (!newFormData.identifier) {
      setValidation(['identifier'])
    } else {
      setValidation([]);
    }
  }

  if (isLoading) {
    return <Spinner />
  }

  return <ModalDialog
    id={dialogId}
    title={`Edit Rack: ${rack.identifier}`}
    icon="pencil"
    buttonText="Edit"
  >
    <div className="uk-align-right">
      <FormInput
        label="Identifier / Reference"
        name="identifier"
        changeFn={formChange}
        data={formData}
        validation={validation}
      />
      <FormInput
        label="Description"
        name="description"
        changeFn={formChange}
        data={formData}
        validation={validation}
      />
      <p className="uk-align-right">
        <a className="uk-button" onClick={(e) => cancel(e)}>Cancel</a>
        <a className="uk-button uk-button-primary" onClick={(e) => saveEdit(e)}>Save</a>
      </p>
    </div>
  </ModalDialog>

}
